import React from "react";
import { routes } from "./config";
import { createBrowserRouter, RouterProvider } from "react-router";
import { buildRoutes } from "./utils";

export const router = createBrowserRouter(buildRoutes(routes));

const Routes: React.FC = () => {
  return <RouterProvider router={router} />;
};

export default Routes;
